'use client'
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";

// src/components/anchors/AnchorsCarousel.tsx
import { Carousel, Typography } from "@wbk/ui";
import { useDeviceDetect } from "@wbk/hooks";
import { jsx, jsxs } from "react/jsx-runtime";
var AnchorsCarousel = ({ section }) => {
  const cards = section.contentCollection.items;
  const sticky = (section == null ? void 0 : section.renderType) === "anchors-sticky";
  const { isWebView } = useDeviceDetect();
  if (!cards.length) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: sticky ? "sticky top-12 z-40 data-[webview=true]:top-0 md:top-16" : "",
      "data-webview": isWebView,
      children: /* @__PURE__ */ jsx(DecoratedSection_default, { section, children: /* @__PURE__ */ jsx(Carousel, { className: "container", children: cards.map((card, i) => /* @__PURE__ */ jsxs("a", { href: card.href, className: "shrink-0 space-y-2 ltr:mr-6 rtl:ml-6", children: [
        !card.icon && /* @__PURE__ */ jsx(
          ContentfulMedia_default,
          {
            media: card.image,
            className: "h-20 w-20 shrink-0 rounded-full md:h-32 md:w-32"
          }
        ),
        /* @__PURE__ */ jsx(Typography, { variant: "label-M", className: "text-center", children: card.title })
      ] }, i)) }) })
    }
  );
};
var AnchorsCarousel_default = AnchorsCarousel;

export {
  AnchorsCarousel_default
};
//# sourceMappingURL=chunk-FPBTIRUM.mjs.map